import { render } from "./AsoProjectsListing.vue?vue&type=template&id=27bf400e&ts=true"
import script from "./AsoProjectsListing.vue?vue&type=script&lang=ts"
export * from "./AsoProjectsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/homebrew/var/www/pickaso/pickaso-reporting-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__